import { render, staticRenderFns } from "./get-charges.vue?vue&type=template&id=24f3d47c&scoped=true"
import script from "./get-charges.vue?vue&type=script&lang=js"
export * from "./get-charges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f3d47c",
  null
  
)

export default component.exports